export default __webpack_public_path__ + "static/media/300.ce4814aa.png";